import { render, staticRenderFns } from "./ProductAttr.vue?vue&type=template&id=7c8cc8f4&scoped=true&"
import script from "./ProductAttr.vue?vue&type=script&lang=js&"
export * from "./ProductAttr.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttr.vue?vue&type=style&index=0&id=7c8cc8f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8cc8f4",
  null
  
)

export default component.exports